import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import ConsentPopup from '../common/ConsentPopup';

class Consent extends Component {
    constructor() {
        super();
        this.state = {
            popupOpen: false
        };

        this.handleOpen = this.handleOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    handleOpen(e) {
        e.preventDefault();
        this.setState({
            popupOpen: true
        });
    }

    handleClose(e) {
        e.preventDefault();
        this.setState({
            popupOpen: false
        });
    }

    render() {
        const {
            title, t, content, linkColor, required
        } = this.props;

        return (
            <Fragment>
                <div className="rodo-triggers">
                    <p className={ cx('rodo-trigger', { notblue: linkColor }) }>
                        {required && '*'}
                        {title.substring(0, title.indexOf('<a>'))}&nbsp;
                    </p>
                    <p onClick={ this.handleOpen } className={ cx('rodo-trigger active', { notblue: linkColor }) }>
                        {title.split('<a>').pop().split('</a>')[0]}
                    </p>
                    <p className={ cx('rodo-trigger', { notblue: linkColor }) }>
                        {title.substring(title.indexOf('</a>') + 4)}
                    </p>
                </div>
                <ConsentPopup t={ t } content={ content } open={ this.state.popupOpen } handleClose={ this.handleClose }/>
            </Fragment>
        );
    }
}

Consent.defaultProps = {
    linkColor: null,
    required: false,
    title: 'asd <a>asds</a>'
};

Consent.propTypes = {
    title: PropTypes.string,
    t: PropTypes.func.isRequired,
    content: PropTypes.string.isRequired,
    linkColor: PropTypes.string,
    required: PropTypes.bool
};

export default Consent;



// WEBPACK FOOTER //
// ./src/components/content/common/Consent.jsx